import { useState } from 'react';
import { Icon } from '@mui/material';
import DownloadableAnchor from '../ui/DownloadableAnchor';

import './StudyDocuments.scss';
import Button from '../ui/Button';

const StudyDocuments = ({
	qamId,
	cretationDate,
	budget,
	informedConsentForm,
	otherDocuments,
	protocol
}) => {
	const [documentsExpanded, setDocumentsExpanded] =
		useState(false);
	const documents = [
		...budget,
		...informedConsentForm,
		...otherDocuments,
		...protocol
	];
	return (
		<div className='documents-data-container'>
			<div
				onClick={() =>
					setDocumentsExpanded(!documentsExpanded)
				}
				className='documents-data-header'
			>
				<div>
					<p> Documents</p>
				</div>
				<span
					className='selector-expand-items documents-data-expander'
					onClick={() =>
						setDocumentsExpanded(!documentsExpanded)
					}
				>
					{!documentsExpanded && (
						<Button className='secondary-button'>
							Show more
							<Icon className='expand-control'>
								expand_more
							</Icon>
						</Button>
					)}
					{documentsExpanded && (
						<Button className='secondary-button'>
							Show less
							<Icon className='expand-control'>
								expand_less
							</Icon>
						</Button>
					)}
				</span>
			</div>
			<div>
				{documentsExpanded && (
					<table
						className='table table-bordered table-hover
					documents-table-container'
					>
						<thead className='table-secondary'>
							<tr>
								<th>File Name </th>
								<th>Uploaded Date</th>
							</tr>
						</thead>
						<tbody>
							{documents.map((document) => {
								return (
									<tr key={document}>
										<td>
											<DownloadableAnchor
												fileName={document}
												qamId={qamId}
											/>
										</td>
										<td>{cretationDate}</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				)}
			</div>
		</div>
	);
};

export default StudyDocuments;
